import { Card } from '@/components/ui/card';
import { DateTimeInterval } from '../types/types';
import Time from './TimeButton';

type TimeListProps = {
  availability: DateTimeInterval[];
};
export default function TimeList({ availability }: TimeListProps) {
  return (
    <div className='w-full p-3 border border-brand-primary-border rounded-lg'>
      <p className='text-lg font-semibold'>Pick a time</p>
      <div className='inline-flex gap-2 py-5 w-[300px] md:w-[450px] lg:w-[550px] 2xl:w-[650px] overflow-x-auto whitespace-nowrap'>
        {availability?.map(slot => (
          <Time key={slot.start.toISOString() + slot.end.toISOString()} time={slot} />
        ))}
      </div>
    </div>
  );
}
